<nav class="login-container-header d-flex" xmlns="http://www.w3.org/1999/html">
  <img
    alt="soregies_logo"
    class="img-logo"
    src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Logos+Groupe+Soregies/Logo+Groupe+Soregies/Logo+Groupe+Soregies.png"
  />
</nav>
<div class="login-page-container">
  <div class="login-container">
    <h2>Connexion</h2>
    <p>Connectez-vous avec votre compte SSO Microsoft</p>
  <button class="sso-button" type="button" (click)="handleSignInWithRedirect()">
    <img src="../../../assets/microsoft.svg" alt="" width="18" height="18" />
    Se connecter avec Microsoft
  </button>
  </div>
</div>